import { render, staticRenderFns } from "./RdaLegendComponent.vue?vue&type=template&id=3acdf05d&scoped=true"
import script from "./RdaLegendComponent.vue?vue&type=script&lang=js"
export * from "./RdaLegendComponent.vue?vue&type=script&lang=js"
import style0 from "./RdaLegendComponent.vue?vue&type=style&index=0&id=3acdf05d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acdf05d",
  null
  
)

export default component.exports